// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "-legacy." + {"48":"f41203f4","108":"fed5b911","193":"20de7eae","260":"c52ffc37","338":"76439dc8","505":"01aeba10","641":"ed6b4f28","681":"c33dd14d","814":"7a3441d9","937":"0360935e","985":"a6168f35"}[chunkId] + ".js";
};